import { render, staticRenderFns } from "./SmsBlastReport.vue?vue&type=template&id=641d5092&scoped=true&lang=pug&"
import script from "./SmsBlastReport.vue?vue&type=script&lang=js&"
export * from "./SmsBlastReport.vue?vue&type=script&lang=js&"
import style0 from "./SmsBlastReport.vue?vue&type=style&index=0&id=641d5092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641d5092",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDataTable,VImg,VProgressCircular,VRow})
